var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"base-not-found"}},[_c('img',{attrs:{"src":require('@/../static/images/404.jpg'),"alt":"Sad catgirl with 404 text :("}}),_vm._v(" "),_c('h1',{staticClass:"title"},[_vm._v("Page not found")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bfe916d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/404.vue
// module id = null
// module chunks = 